// extracted by mini-css-extract-plugin
export var circle = "_fu-1";
export var exitConfirmationModal = "_fu-5";
export var iframe = "_fu-0";
export var offline = "_fu-3";
export var online = "_fu-2";
export var workstationSelectError = "_fu-4";